import NotificationsIcon from '@mui/icons-material/Notifications'
import Badge from '@mui/material/Badge'
import { styled } from '@mui/material/styles'

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'animate',
})<{ animate: boolean }>(({ animate }) => ({
  ...(animate && {
    '& .MuiBadge-badge': {
      animation: 'badgeAttention 1s ease-in-out 1',
    },

    '@keyframes badgeAttention': {
      '0%, 100%': {
        filter: 'brightness(1)',
      },
      '50%': {
        filter: 'brightness(1.25)',
      },
    },
  }),
}))

export const StyledNotificationsIcon = styled(NotificationsIcon, {
  shouldForwardProp: (prop) => prop !== 'animate',
})<{ animate: boolean }>(({ animate }) => ({
  animation: animate ? 'shake 1s ease-in-out 2' : 'none',

  '@keyframes shake': {
    '0%, 100%': {
      transform: 'rotate(0deg) scale(1)',
    },
    '20%': {
      transform: 'rotate(-20deg) scale(1.1)',
    },
    '40%': {
      transform: 'rotate(20deg) scale(1.2)',
    },
    '60%': {
      transform: 'rotate(-7deg) scale(1.1)',
    },
    '80%': {
      transform: 'rotate(7deg) scale(1.05)',
    },
  },
}))
